export interface Category {
  name: string;
  url: string;
  icon: string;
  description: string;
  image: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Latest sneakers, athletic shoes, and designer footwear from trusted sellers',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20pair%20of%20white%20premium%20designer%20sneakers%20on%20cream%20beige%20surface%2C%20soft%20natural%20lighting%2C%20simple%20elegant%20composition%2C%20editorial%20fashion%20style%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-img-shoes-2026&orientation=landscape',
  },
  {
    name: 'Hoodies & Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Premium hoodies, crewnecks, and sweaters for every season',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20fashion%20photography%20of%20a%20folded%20grey%20premium%20cotton%20hoodie%20on%20cream%20white%20background%2C%20soft%20diffused%20lighting%2C%20clean%20editorial%20aesthetic%2C%20warm%20neutral%20palette%2C%20subtle%20texture%20details&width=400&height=300&seq=cat-img-hoodies-2026&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Graphic tees, designer t-shirts, and everyday basics',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20folded%20black%20premium%20cotton%20t-shirt%20on%20cream%20beige%20surface%2C%20soft%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-img-tshirts-2026&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-cloud-windy-line',
    description: 'Bombers, varsity jackets, denim jackets, and outerwear',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20product%20photography%20of%20a%20stylish%20olive%20green%20bomber%20jacket%20on%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20aesthetic%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-img-jackets-2026&orientation=landscape',
  },
  {
    name: 'Pants & Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-user-line',
    description: 'Cargo pants, jeans, shorts, and streetwear bottoms',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20folded%20beige%20cargo%20pants%20on%20cream%20white%20surface%2C%20soft%20diffused%20lighting%2C%20editorial%20fashion%20style%2C%20warm%20neutral%20palette&width=400&height=300&seq=cat-img-pants-2026&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-customer-service-line',
    description: 'Caps, beanies, bucket hats, and trendy headwear',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20stylish%20black%20baseball%20cap%20on%20cream%20beige%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20aesthetic%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-img-headwear-2026&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Matching tracksuits, coordinated sets, and full outfits',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20matching%20grey%20tracksuit%20set%20folded%20on%20cream%20white%20background%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20style%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-img-sets-2026&orientation=landscape',
  },
  {
    name: 'Underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-user-heart-line',
    description: 'Comfortable underwear, boxers, and basics',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20folded%20white%20cotton%20underwear%20on%20cream%20beige%20surface%2C%20soft%20diffused%20lighting%2C%20simple%20elegant%20composition%2C%20warm%20neutral%20palette&width=400&height=300&seq=cat-img-underwear-2026&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-football-line',
    description: 'Sports jerseys, football kits, and athletic wear',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20product%20photography%20of%20a%20folded%20red%20sports%20jersey%20on%20cream%20white%20background%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-img-jersey-2026&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Sunglasses, watches, jewelry, and fashion accessories',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20pair%20of%20stylish%20sunglasses%20and%20a%20watch%20on%20cream%20beige%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-img-accessories-2026&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    description: 'Backpacks, shoulder bags, duffel bags, and travel gear',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20stylish%20brown%20leather%20backpack%20on%20cream%20white%20background%2C%20soft%20natural%20lighting%2C%20editorial%20aesthetic%2C%20warm%20neutral%20palette&width=400&height=300&seq=cat-img-bags-2026&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Designer belts, leather belts, and fashion straps',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20rolled%20black%20leather%20belt%20with%20gold%20buckle%20on%20cream%20beige%20surface%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-img-belts-2026&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-contrast-drop-line',
    description: 'Designer fragrances, colognes, and premium perfumes',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20glass%20perfume%20bottle%20on%20cream%20white%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20beauty%20style%2C%20warm%20neutral%20palette&width=400&height=300&seq=cat-img-perfumes-2026&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Electronics, home goods, gadgets, and miscellaneous finds',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20miscellaneous%20lifestyle%20items%20including%20headphones%20and%20gadgets%20on%20cream%20beige%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones&width=400&height=300&seq=cat-img-other-2026&orientation=landscape',
  },
];

export const comparisonData = [
  {
    platform: 'AllChinaBuy Spreadsheet',
    productLinks: 'Excellent',
    qcSupport: 'Excellent',
    easeOfUse: 'Easy',
    updates: 'Daily',
  },
  {
    platform: 'CNFans',
    productLinks: 'Good',
    qcSupport: 'Good',
    easeOfUse: 'Easy',
    updates: 'Weekly',
  },
  {
    platform: 'Superbuy',
    productLinks: 'Average',
    qcSupport: 'Good',
    easeOfUse: 'Medium',
    updates: 'Weekly',
  },
  {
    platform: 'Sugargoo',
    productLinks: 'Average',
    qcSupport: 'Average',
    easeOfUse: 'Medium',
    updates: 'Monthly',
  },
];

export const faqItems = [
  {
    question: 'Is the AllChinaBuy Spreadsheet safe to use?',
    answer: 'Yes, the AllChinaBuy Spreadsheet is completely safe. It is a curated directory of product links from verified sellers on AllChinaBuy. Our team regularly checks and updates every link to ensure they lead to legitimate products. We also include QC guides and safety tips to help you shop with confidence. Thousands of buyers use our AllChinaBuy Spreadsheet daily without any security issues.',
  },
  {
    question: 'How often is the AllChinaBuy Spreadsheet updated?',
    answer: 'Our AllChinaBuy Spreadsheet is updated daily. We constantly monitor seller activity, remove dead links, add new product discoveries, and refresh QC information. Unlike other spreadsheets that go months without updates, we ensure you always have access to the freshest AllChinaBuy Spreadsheet data available in 2026.',
  },
  {
    question: 'Can beginners use the AllChinaBuy Spreadsheet?',
    answer: 'Absolutely. Our AllChinaBuy Spreadsheet is designed to be beginner-friendly. Each category is clearly organized, every product includes detailed descriptions, and we provide step-by-step shipping and buying tutorials. Even if you have never used AllChinaBuy before, you can start shopping within minutes using our spreadsheet.',
  },
  {
    question: 'Which sellers are trusted in the AllChinaBuy Spreadsheet?',
    answer: 'Our AllChinaBuy Spreadsheet only includes sellers who have been verified through multiple successful transactions, positive buyer feedback, and consistent product quality. We maintain a strict vetting process and regularly review seller performance. The spreadsheet clearly marks trusted sellers so you can shop with confidence.',
  },
  {
    question: 'What products are available in the AllChinaBuy Spreadsheet?',
    answer: 'The AllChinaBuy Spreadsheet covers over 5,000 products across 14 categories including Shoes, Hoodies & Sweaters, T-Shirts, Jackets, Pants & Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and more. From sneakers and streetwear to luxury brands and budget finds, our spreadsheet has something for everyone.',
  },
  {
    question: 'How does the AllChinaBuy Spreadsheet compare to other buying platforms?',
    answer: 'Our AllChinaBuy Spreadsheet outperforms other platforms with daily updates, verified seller lists, comprehensive QC guides, and beginner-friendly shipping tutorials. While platforms like CNFans and Superbuy offer weekly updates, our spreadsheet provides the most current product links and the largest curated selection of trusted sellers.',
  },
];

export const trustStats = [
  { label: 'Updated Daily', icon: 'ri-refresh-line' },
  { label: '5,000+ Products', icon: 'ri-shopping-bag-line' },
  { label: '300+ Sellers', icon: 'ri-user-star-line' },
  { label: 'QC Guides Included', icon: 'ri-shield-check-line' },
  { label: 'Safe Shopping Tips', icon: 'ri-shield-flash-line' },
];

export interface ArticleCard {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  category: string;
  readTime: string;
}

export const seoArticles: ArticleCard[] = [
  {
    slug: 'trusted-allchinabuy-sellers-2026',
    title: 'Top 20 Trusted AllChinaBuy Sellers in 2026',
    excerpt: 'Discover the most reliable and verified sellers on AllChinaBuy. Our team has tested and reviewed every seller to ensure quality products and safe transactions.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20minimalist%20photography%20of%20a%20workspace%20with%20laptop%20showing%20seller%20ratings%20and%20product%20samples%20scattered%20on%20cream%20white%20desk%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-sellers-2026&orientation=landscape',
    category: 'Trusted Sellers',
    readTime: '10 min read',
  },
  {
    slug: 'allchinabuy-shipping-guide-2026',
    title: 'AllChinaBuy Shipping Guide 2026: Complete Tutorial',
    excerpt: 'Master AllChinaBuy shipping with our step-by-step tutorial. Learn about shipping lines, declaration tips, customs handling, and how to save on international delivery.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20photography%20of%20a%20cardboard%20shipping%20box%20with%20packing%20tape%20next%20to%20a%20world%20map%20on%20cream%20white%20desk%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-shipping-2026&orientation=landscape',
    category: 'Shipping',
    readTime: '8 min read',
  },
  {
    slug: 'allchinabuy-qc-guide-2026',
    title: 'Ultimate AllChinaBuy QC Guide: Inspect Like a Pro',
    excerpt: 'Learn how to read QC photos, spot common flaws, and request better pictures. Our QC guide helps you avoid disappointing purchases and get exactly what you ordered.',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20photography%20of%20a%20magnifying%20glass%20over%20product%20detail%20shots%20on%20cream%20white%20desk%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-qc-2026&orientation=landscape',
    category: 'QC Guide',
    readTime: '12 min read',
  },
  {
    slug: 'allchinabuy-beginners-guide-2026',
    title: 'AllChinaBuy Spreadsheet for Beginners: Start Here',
    excerpt: 'New to AllChinaBuy? This beginner-friendly guide walks you through everything from creating an account to placing your first order using our spreadsheet.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20photography%20of%20a%20clean%20desk%20with%20a%20notebook%20pen%20and%20smartphone%20on%20cream%20white%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-beginners-2026&orientation=landscape',
    category: 'Beginners',
    readTime: '7 min read',
  },
  {
    slug: 'allchinabuy-vs-cnfans-2026',
    title: 'AllChinaBuy Spreadsheet vs CNFans: Full Comparison',
    excerpt: 'Detailed comparison between AllChinaBuy Spreadsheet and CNFans. Compare product selection, seller verification, shipping costs, and overall buying experience.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20photography%20of%20two%20laptops%20side%20by%20side%20showing%20comparison%20data%20on%20cream%20white%20desk%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-vs-cnfans-2026&orientation=landscape',
    category: 'Comparison',
    readTime: '9 min read',
  },
  {
    slug: 'allchinabuy-sneakers-guide-2026',
    title: 'Best Sneakers on AllChinaBuy Spreadsheet 2026',
    excerpt: 'Find the hottest sneakers from trusted sellers. Our curated sneaker guide covers Air Jordans, Dunks, Yeezys, New Balance, and more with verified links.',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20minimalist%20photography%20of%20a%20pair%20of%20trendy%20white%20designer%20sneakers%20on%20cream%20beige%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20style%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-sneakers-2026&orientation=landscape',
    category: 'Sneakers',
    readTime: '11 min read',
  },
  {
    slug: 'allchinabuy-luxury-brands-2026',
    title: 'Luxury Brands on AllChinaBuy Spreadsheet: Complete List',
    excerpt: 'Access premium luxury brands through our verified spreadsheet. From Gucci to Balenciaga, find authentic-quality products at accessible prices.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20photography%20of%20a%20luxury%20handbag%20and%20designer%20accessories%20on%20cream%20white%20background%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20style%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-luxury-2026&orientation=landscape',
    category: 'Luxury',
    readTime: '9 min read',
  },
  {
    slug: 'allchinabuy-safety-tips-2026',
    title: 'AllChinaBuy Spreadsheet Safety Tips: Shop Securely',
    excerpt: 'Protect yourself while shopping on AllChinaBuy. Learn about payment safety, scam prevention, return policies, and how to identify trustworthy sellers.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20photography%20of%20a%20shield%20icon%20and%20padlock%20on%20cream%20white%20desk%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-safety-2026&orientation=landscape',
    category: 'Safety',
    readTime: '8 min read',
  },
  {
    slug: 'allchinabuy-budget-finds-2026',
    title: 'Best Budget Finds on AllChinaBuy Spreadsheet 2026',
    excerpt: 'Discover amazing deals and budget-friendly products without compromising quality. Our spreadsheet highlights the best value purchases under every category.',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20photography%20of%20various%20affordable%20fashion%20items%20and%20accessories%20arranged%20on%20cream%20white%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-budget-2026&orientation=landscape',
    category: 'Budget',
    readTime: '7 min read',
  },
];